import apiFetch from '../apiFetch'

export default function (dossierId, isHistorical, token) {
  return apiFetch({ endPoint: `Document/MassiveDownload/GetDocumentsDossier?dossierId=${dossierId}&historical=${isHistorical}`, method: 'GET', token: token })
}
